import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives/directives.module';
import { TextHighlightModule } from '../text-highlight';
import { TreeviewItemComponent } from './treeview-item/treeview-item.component';
import { TreeviewComponent } from './treeview.component';

@NgModule({
    imports: [CommonModule, FormsModule, TwcModule, TextHighlightModule, DirectivesModule, TranslateModule],
    exports: [TreeviewComponent],
    declarations: [TreeviewComponent, TreeviewItemComponent],
    providers: [],
})
export class TreeViewModule {}
